import React, { Component } from 'react';
import { Segment } from 'semantic-ui-react';
import logoHanen from './assets/hanen.svg';
import logoNot from './assets/not.svg';

class Header extends Component {
  render() {
    return (
      <div>
        <Segment
          basic
          className="samarbeid-hanen"
          size="small"
          textAlign="center"
        >
          <img src={logoHanen} alt="Hanen logo" className="hanen" />
          <br />
          Sertifiseringen driftes av HANEN.
        </Segment>
        <hr className="separate-hanen-not" />
        <Segment basic textAlign="center">
          <img src={logoNot} alt="Norsk økoturisme logo" className="not" />
        </Segment>,
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header.js